module.exports = __webpack_public_path__ + "img/cq-tab-icon4.fc737466.png";